module.exports = __webpack_public_path__ + "static/media/video-watch-taggis.f915cd2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-watch-taggis.jpg
// module id = 88
// module chunks = 3